import React from 'react';
import { NavLink } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

interface Props {
  to: string;
  label: string;
  icon: LucideIcon;
  collapsed: boolean;
  /** Tailwind gradient of the card, shown as the icon chip. */
  color?: string;
  end?: boolean;
}

/** One sidebar link — icon chip + label; label becomes a tooltip in the icon rail. */
export const AdminSidebarItem: React.FC<Props> = ({ to, label, icon: Icon, collapsed, color, end }) => (
  <NavLink
    to={to}
    end={end}
    title={collapsed ? label : undefined}
    className={({ isActive }) =>
      `flex items-center gap-2.5 rounded-lg px-2 py-1.5 text-sm transition-colors ${
        collapsed ? 'justify-center' : ''
      } ${isActive ? 'bg-primary/10 text-primary-700 font-medium' : 'text-neutral-700 hover:bg-neutral-100'}`
    }
  >
    <span
      className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md ${
        color ? `bg-gradient-to-br ${color} text-white` : 'text-neutral-500'
      }`}
    >
      <Icon className="h-3.5 w-3.5" />
    </span>
    {!collapsed && <span className="truncate">{label}</span>}
  </NavLink>
);
